/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	PasswordInput as NativePasswordInput,
	PasswordInputProps,
} from '@mantine/core';

// Styles
import classes from './PasswordInput.module.css';

// Icons
import { IconEye, IconEyeOff } from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */

export type TTextInputProps = PasswordInputProps;

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const PasswordInput = (
	props: PasswordInputProps
) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<NativePasswordInput
			visibilityToggleIcon={({ reveal }) =>
				reveal ? (
					<IconEye color="#9BA6B7" size="18px" />
				) : (
					<IconEyeOff color="#9BA6B7" size="18px" />
				)
			}
			classNames={classes}
			{...props}
		/>
	);
};
